// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".native_img_style[data-v-3b3edb19]{max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
